import state from './outletState'
import mutations from './outletMutations'
import getters from './outletGetters'
import actions from './outletActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
